var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as lodash from '../../utils/lodash';
import { Rect, Group, createRef, createText, } from '../../element';
import { axisType } from '../../interface/axis';
import ComponentModel from '../../model/componentModel';
import normalizeToArray from '../../utils/normalizeToArray';
import { degToRad, getPercentOrNumberValue, log10 } from '../../utils/math';
import merge from '../../utils/merge';
import { getDefaultMarkAreaOption } from './markArea';
import { getPadding } from '../../utils/styleHelper';
export function getDefaultCrosshairOption() {
    return {
        type: null,
        onTopLevel: false,
        lineStyle: {
            stroke: '#AFB5CC',
            lineWidth: 1,
        },
        shadowStyle: {
            fill: '#E0E2EB',
            opacity: 0.3,
            lineWidth: 0,
            stroke: null,
        },
        label: {
            show: false,
            formatter: null,
            padding: 4,
            backgroundStyle: {
                fill: '#878EA8',
                borderRadius: 2,
            },
            textStyle: {
                color: '#ffffff',
                fontSize: 12,
            },
        },
    };
}
/**
 * abstract axis
 */
var Axis = /** @class */ (function (_super) {
    __extends(Axis, _super);
    function Axis() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.labelRef = {};
        _this.crossLabelRef = createRef();
        _this.autoRotate = 0;
        _this.handleMarkLineMouseOver = function (event) {
            _this.togglelHighlightMarkline(event, true);
        };
        _this.handleMarkLineMouseOut = function (event) {
            _this.togglelHighlightMarkline(event, false);
        };
        return _this;
    }
    Axis.prevProcessOption = function (option) {
        option.xAxis = normalizeToArray(option.xAxis || [{ type: 'category' }]);
        option.yAxis = normalizeToArray(option.yAxis || [{ type: 'value' }]);
        option.angleAxis = normalizeToArray(option.angleAxis || [{ type: 'category' }]);
        option.radiusAxis = normalizeToArray(option.radiusAxis || [{ type: 'value' }]);
        __spreadArrays(option.xAxis, option.yAxis).forEach(function (axis) {
            axis.grid = axis.grid || 0;
        });
        option.xAxis.concat(option.yAxis).forEach(function (axis) {
            if (lodash.isBoolean(axis.oppsoite)) {
                axis.opposite = axis.oppsoite;
            }
        });
        option.yAxis.forEach(function (axis) {
            if (!axis.type) {
                axis.type = 'value';
            }
        });
    };
    Axis.prototype.getDefaultOption = function (option, extraInfo) {
        var index = extraInfo.index;
        var prevAxis = this.chart.getOption()[this.type].slice(0, index);
        var otherAxisMap = {
            xAxis: 'yAxis',
            yAxis: 'xAxis',
            angleAxis: 'radiusAxis',
            radiusAxis: 'angleAxis',
        };
        var otherAxis = otherAxisMap[this.type];
        var otherAxisType = this.chart.getOption()[otherAxis][0].type;
        var showAxisLine = true;
        var showGridLine = !(option.type === 'category' || option.type === 'time');
        if (showGridLine &&
            (otherAxisType === 'category' || otherAxisType === 'time') &&
            (this.type === 'xAxis' || this.type === 'yAxis')) {
            showAxisLine = false;
        }
        var defaultMarkLineOption = {
            value: null,
            trigger: 'line',
            label: {
                show: true,
                text: '',
                position: 'end',
                distance: 4,
                color: '#EB5A44',
                fontSize: 12,
                offsetY: 0,
                offsetX: 0,
            },
            lineStyle: {
                lineWidth: 1,
                lineDash: [4, 3],
                stroke: '#EB5A44',
                cursor: 'pointer',
            },
            icon: {
                show: true,
                symbol: null,
                size: 16,
                fill: '#F65656',
                stroke: null,
                lineWidth: 0,
                cursor: 'pointer',
            },
            hover: {
                icon: {
                    show: true,
                },
                label: {
                    show: true,
                    fontSize: null,
                },
                lineStyle: {
                    lineWidth: null,
                    stroke: null,
                },
            },
        };
        return {
            show: true,
            type: 'value',
            nice: true,
            logBase: 10,
            polar: 0,
            grid: 0,
            autoRange: true,
            min: null,
            max: null,
            softMin: option.type === 'value' ? 0 : null,
            softMax: option.type === 'value' ? 0 : null,
            inverse: false,
            tickCount: 5,
            exactTickCount: false,
            interval: null,
            minInterval: null,
            maxInterval: null,
            offset: 0,
            ticks: null,
            allowDecimals: true,
            title: {
                text: '',
                align: 'end',
                show: true,
                margin: 8,
                rotate: null,
                offsetX: 0,
                offsetY: 0,
                textStyle: {
                    fontSize: 12,
                    color: '#999999',
                    textAlign: null,
                    textBaseline: null,
                },
            },
            opposite: index > 0 && prevAxis.some(function (axis) { return axis.grid === option.grid; }),
            alternateColor: null,
            padding: true,
            axisLine: {
                show: showAxisLine,
                stroke: '#6E748E',
                lineWidth: 1,
                lineDash: null,
            },
            axisLabel: {
                show: true,
                interval: 'auto',
                inside: false,
                rotate: 0,
                margin: 12,
                offsetX: 0,
                offsetY: 0,
                formatter: null,
                fontSize: 12,
                color: '#6E748E',
                alignToAxis: false,
            },
            tickLine: {
                show: showAxisLine,
                interval: 0,
                inside: false,
                length: 4,
                stroke: '#6E748E',
                lineDash: null,
                lineWidth: 1,
                alignWithLabel: false,
            },
            gridLine: {
                show: showGridLine && index === 0,
                stroke: '#E0E2EB',
                lineWidth: 1,
                // lineDash: [4, 5],
                shape: 'auto',
            },
            markLines: (option.markLines || []).map(function (markLineOption) {
                return lodash.merge({}, defaultMarkLineOption, markLineOption);
            }),
            markAreas: (option.markAreas || []).map(function (markAreaOption) {
                return lodash.merge(getDefaultMarkAreaOption(), markAreaOption);
            }),
            breaks: (option.breaks || []).map(function (breakOption) { return (__assign({ breakSize: 0 }, breakOption)); }),
        };
    };
    Axis.prototype.getThemeOption = function (option) {
        var axisTheme = this.chart.getTheme();
        var type = option.type;
        var themeOption = type === 'category' ? axisTheme.categoryAxis : axisTheme.valueAxis;
        return merge({}, themeOption, {
            gridLine: this.extraInfo.index === 1 ? { show: false } : {},
        });
    };
    Axis.prototype.init = function () {
        this.initScale();
        this.registerEvent('markLine:mouseover', this.handleMarkLineMouseOver);
        this.registerEvent('markLine:mouseout', this.handleMarkLineMouseOut);
    };
    Axis.prototype.getCategories = function () {
        var allAxisSeries = this.getAxisSeries(true).filter(function (series) { return series.getDataset().count() > 0; });
        var firstSeiresModel = allAxisSeries[0];
        if (firstSeiresModel) {
            var dataKey = firstSeiresModel.getEncoder().getAxisField(this.type);
            return firstSeiresModel.getCategories(dataKey);
        }
        return [];
    };
    Axis.prototype.getDatakey = function () {
        var dataKey = '';
        var axisSeries = this.getAxisSeries(true);
        if (axisSeries.length > 0) {
            dataKey = normalizeToArray(axisSeries[0].getEncoder().getAxisField(this.type))[0];
        }
        return dataKey;
    };
    Axis.prototype.getSliderExtreme = function () {
        var extreme = this.getExtreme(true);
        var min = lodash.isNumber(this.option.min) ? this.option.min : extreme[0];
        var max = lodash.isNumber(this.option.max) ? this.option.max : extreme[1];
        return [min, max];
    };
    Axis.prototype.getExtreme = function (allData) {
        var _this = this;
        if (allData === void 0) { allData = false; }
        var _a = this.option, type = _a.type, padding = _a.padding;
        var allAxisSeries = this.getAxisSeries(true);
        var axisSeries = allAxisSeries.filter(function (series) { return series.visible(); });
        var min = 0;
        var max = 1;
        if (type === axisType.CATEGORY) {
            var categories = this.getCategories();
            min = 0;
            if (categories.length > 0) {
                max = categories.length - 1;
            }
            min = lodash.isNumber(this.option.min) && !allData ? this.option.min : min;
            max = lodash.isNumber(this.option.max) && !allData ? this.option.max : max;
            var splitData = categories.map(function (val, index) { return index; });
            if (max > splitData.length - 1 || typeof max !== 'number') {
                max = splitData[splitData.length - 1];
            }
            splitData = splitData.slice(Math.round(min), Math.round(min) + Math.round(max - min) + 1);
            min = splitData[0];
            max = splitData[splitData.length - 1];
        }
        else {
            var seriesExtremeData = lodash.flatten(axisSeries.map(function (seriesModel) {
                var dataKey = seriesModel.getEncoder().getAxisField(_this.type);
                return seriesModel.getStackedExtreme(dataKey, _this.type, allData);
            }));
            var minValue = lodash.min(seriesExtremeData);
            var maxValue = lodash.max(seriesExtremeData);
            var range = maxValue - minValue;
            if (lodash.isArray(padding)) {
                minValue -= getPercentOrNumberValue(padding[0], range);
                maxValue += getPercentOrNumberValue(padding[1], range);
            }
            min = lodash.isNumber(this.option.min) && !allData ? this.option.min : minValue;
            max = lodash.isNumber(this.option.max) && !allData ? this.option.max : maxValue;
            if (min === 0 && max === 0) {
                max = 1;
            }
            if (lodash.isNumber(this.option.softMin) &&
                this.option.softMin < min &&
                !lodash.isNumber(this.option.min)) {
                min = this.option.softMin;
            }
            if (lodash.isNumber(this.option.softMax) &&
                this.option.softMax > max &&
                !lodash.isNumber(this.option.max)) {
                max = this.option.softMax;
            }
        }
        return [min, max];
    };
    Axis.prototype.getLabelAreaSize = function () {
        return {
            side: '',
            size: 0,
        };
    };
    Axis.prototype.getAutoRotate = function () {
        var _a = this.option.axisLabel, rotate = _a.rotate, fontSize = _a.fontSize, autoRotate = _a.autoRotate;
        this.autoRotate = rotate;
        if (this.type !== 'xAxis' || !(autoRotate === null || autoRotate === void 0 ? void 0 : autoRotate.length)) {
            return rotate;
        }
        var _b = this.state.labelSizeList, labelSizeList = _b === void 0 ? [] : _b;
        var intervalWidth = Math.abs(1 / this.getPixelValue());
        var maxLabelWidth = lodash.max(labelSizeList.map(function (size) { return size.width; }));
        if (maxLabelWidth > intervalWidth) {
            this.autoRotate = lodash.minBy(autoRotate, function (autoDeg) {
                var autoIntervalWidth = 0;
                if (autoDeg === 0) {
                    var minDistance = 4;
                    for (var i = 0; i < labelSizeList.length - 1; i++) {
                        var currentSize = labelSizeList[i].width;
                        var nextSize = labelSizeList[i + 1].width;
                        autoIntervalWidth = Math.max(autoIntervalWidth, minDistance + (nextSize + currentSize) / 2);
                    }
                }
                else {
                    autoIntervalWidth = Math.min(maxLabelWidth / Math.cos(degToRad(autoDeg)), Math.abs(fontSize / Math.sin(degToRad(autoDeg))));
                }
                return Math.abs(Math.ceil(autoIntervalWidth / intervalWidth)) - 1;
            });
        }
        return this.autoRotate;
    };
    Axis.prototype.getIntervalTicks = function () {
        var _this = this;
        var ticks = this.scale.getTicks();
        var _a = this.option.axisLabel, rotate = _a.rotate, fontSize = _a.fontSize, autoRotate = _a.autoRotate;
        // autoInterval
        var _b = this.state.labelSizeList, labelSizeList = _b === void 0 ? [] : _b;
        var intervalWidth = Math.abs(1 / this.getPixelValue());
        var minDistance = 4;
        var minIntervalWidth = intervalWidth;
        var maxLabelWidth = lodash.max(labelSizeList.map(function (size) { return size.width; }));
        // when label inside, labelSizeList is empty
        var maxLabelHeight = lodash.max(labelSizeList.map(function (size) { return size.height; })) || fontSize;
        // intervalWidth is Infinite
        if (ticks.length === 1) {
            return ticks;
        }
        if (this.isCategroy()) {
            if (lodash.isNumber(this.option.interval)) {
                return ticks.filter(function (tick, index) { return index % _this.option.interval === 0; });
            }
            if (this.type === 'xAxis') {
                if (rotate !== 0) {
                    minIntervalWidth = Math.min(maxLabelWidth / Math.cos(degToRad(rotate)), Math.abs(fontSize / Math.sin(degToRad(rotate))));
                }
                else {
                    for (var i = 0; i < labelSizeList.length - 1; i++) {
                        var currentSize = labelSizeList[i].width;
                        var nextSize = labelSizeList[i + 1].width;
                        minIntervalWidth = Math.max(minIntervalWidth, minDistance + (nextSize + currentSize) / 2);
                    }
                }
                var autoInterval_1 = Math.ceil(minIntervalWidth / intervalWidth);
                if (autoInterval_1 !== 1 && (autoRotate === null || autoRotate === void 0 ? void 0 : autoRotate.length)) {
                    var bestAutoRotate = this.autoRotate;
                    var bestIntervalWidth = Math.min(maxLabelWidth / Math.cos(degToRad(bestAutoRotate)), Math.abs(fontSize / Math.sin(degToRad(bestAutoRotate))));
                    autoInterval_1 = Math.ceil(bestIntervalWidth / intervalWidth);
                }
                return ticks.filter(function (tick, index) { return index % autoInterval_1 === 0; });
            }
            if (this.type === 'yAxis') {
                minIntervalWidth = (maxLabelHeight + minDistance) / Math.cos(degToRad(rotate));
                var autoInterval_2 = Math.ceil(minIntervalWidth / intervalWidth);
                return ticks.filter(function (tick, index) { return index % autoInterval_2 === 0; });
            }
            return ticks;
        }
        return ticks;
    };
    Axis.prototype.getAxisSeries = function (isAll) {
        if (isAll === void 0) { isAll = false; }
        var _a = this.extraInfo, index = _a.index, axis = _a.axis;
        var axisPolarIndex = this.option.polar;
        var coordSeries = this.parentModel.getDependentSeries();
        if (!isAll) {
            coordSeries = coordSeries.filter(function (seriesModel) { return seriesModel.visible(); });
        }
        return coordSeries.filter(function (model) {
            var _a = model.getOption(), coord = _a.coord, xAxis = _a.xAxis, yAxis = _a.yAxis, polarIndex = _a.polar;
            if (coord === 'cartesian2d') {
                if (axis === 'xAxis') {
                    return xAxis === index;
                }
                if (axis === 'yAxis') {
                    return yAxis === index;
                }
            }
            else if (coord === 'polar') {
                return polarIndex === axisPolarIndex;
            }
        });
    };
    Axis.prototype.getDirection = function () {
        var inverse = this.option.inverse;
        if (this.type === 'xAxis') {
            return inverse ? 'left' : 'right';
        }
        if (this.type === 'yAxis') {
            return inverse ? 'bottom' : 'top';
        }
        if (this.type === 'radiusAxis') {
            return inverse ? 'innerRadius' : 'radius';
        }
        if (this.type === 'angleAxis') {
            return inverse ? 'startAngle' : 'endAngle';
        }
    };
    Axis.prototype.getPixelValue = function () {
        var _a = this.scale.getPositionRange(), start = _a[0], end = _a[1];
        var _b = this.scale.getValueDomain(), min = _b[0], max = _b[1];
        if (this.parentModel.type === 'grid') {
            return (max - min) / (end - start);
        }
        if (this.parentModel.type === 'polar') {
            var radius = this.parentModel.getState().radius;
            if (this.extraInfo.axis === 'angleAxis') {
                var arcLength = ((end - start) / 360) * Math.PI * radius * 2;
                return (max - min) / arcLength;
            }
            if (this.extraInfo.axis === 'radiusAxis') {
                return (max - min) / (end - start);
            }
        }
    };
    Axis.prototype.getCrosshairsOption = function () {
        var _a;
        var option = this.chart.getOption();
        if (option.tooltip && option.tooltip.crosshairs) {
            if (this.chart.getComponentModel('tooltip')) {
                return merge({}, option.tooltip.crosshairs, this.option.crosshairs);
            }
            return merge(getDefaultCrosshairOption(), (_a = option.tooltip) === null || _a === void 0 ? void 0 : _a.crosshairs, this.option.crosshairs);
        }
        return merge(getDefaultCrosshairOption(), this.option.crosshairs);
    };
    Axis.prototype.getCrossLineStyle = function () {
        var crosshairs = this.getCrosshairsOption();
        return this.getLineStyle(crosshairs.lineStyle);
    };
    Axis.prototype.getCrossShadowStyle = function () {
        var crosshairs = this.getCrosshairsOption();
        var shadowConf = crosshairs.shadowStyle;
        return this.getShapeStyle(shadowConf);
    };
    Axis.prototype.isCategroy = function () {
        return this.option.type === axisType.CATEGORY;
    };
    Axis.prototype.shoudUseShadowPointer = function () {
        var lineCross = ['line', 'area', 'streamgraph'];
        return (this.parentModel
            .getDependentSeries()
            .some(function (seriesModel) { return !lodash.includes(lineCross, seriesModel.type); }) &&
            this.parentModel.getAllAxis().some(function (axis) { return axis.isCategroy(); }));
    };
    Axis.prototype.hideCrosshair = function () {
        var _a, _b, _c;
        (_a = this.crossLine) === null || _a === void 0 ? void 0 : _a.setAttr('display', false);
        (_b = this.crossShadow) === null || _b === void 0 ? void 0 : _b.setAttr('display', false);
        (_c = this.crossLabelRef.current) === null || _c === void 0 ? void 0 : _c.hide();
    };
    Axis.prototype.afterRender = function () {
        if (this.getAxisSeries().filter(function (seriesModel) { return seriesModel.visible(); }).length === 0) {
            this.hideCrosshair();
        }
    };
    Axis.prototype.getTickLabels = function () {
        return this.labelRef;
    };
    Axis.prototype.togglelHighlightMarkline = function (event, active) {
        var _a;
        var markLine = event.markLine, elments = event.elments;
        var option = active ? markLine.hover : markLine;
        var icon = option.icon, label = option.label, lineStyle = option.lineStyle;
        (_a = elments.icon.current) === null || _a === void 0 ? void 0 : _a.setAttr(__assign({ display: icon.show }, this.getShapeStyle(icon)));
        elments.label.current.setAttr(__assign({ display: label.show }, this.getTextStyle(label)));
        elments.line.current.setAttr(__assign({}, this.getLineStyle(lineStyle)));
    };
    Axis.prototype.pickTicks = function (ticks) {
        var maxCount = 200;
        var ret = [];
        var interval = Math.max(Math.ceil(ticks.length / maxCount), 1);
        for (var i = 0; i < ticks.length; i += interval) {
            ret.push(ticks[i]);
        }
        return ret;
    };
    Axis.prototype.renderCrossLabel = function () {
        var label = this.getCrosshairsOption().label;
        var group = new Group({
            key: this.getKey('cross-label'),
            ref: this.crossLabelRef,
            display: false,
            pointerEvents: 'none',
        });
        group.add(new Rect(__assign({}, label.backgroundStyle)));
        group.add(createText(__assign({}, this.getTextStyle(label.textStyle))));
        return group;
    };
    Axis.prototype.showCrossLabel = function (x, y, content) {
        var _a = this.option, opposite = _a.opposite, _b = _a.axisLabel, margin = _b.margin, fontSize = _b.fontSize;
        var label = this.getCrosshairsOption().label;
        if (!label.show) {
            return;
        }
        var chartWidth = this.chart.getWidth();
        var group = this.crossLabelRef.current;
        var bgRect = group.childAt(0);
        var text = group.childAt(1);
        var textAlign = 'center';
        var textBaseline = 'middle';
        if (this.type === 'xAxis') {
            y += opposite ? -margin - fontSize / 2 : margin + fontSize / 2;
        }
        if (this.type === 'yAxis') {
            textAlign = opposite ? 'left' : 'right';
            x += opposite ? margin : -margin;
        }
        var formattedContent = label.formatter
            ? label.formatter({ value: content, dataIndex: null })
            : this.formatCrossLabel(content);
        group.show();
        text.setAttr({
            x: x,
            y: y,
            text: formattedContent,
            textAlign: textAlign,
            textBaseline: textBaseline,
        });
        var bbox = text.getBBox();
        var _c = getPadding(label.padding), paddingLeft = _c.paddingLeft, paddingRight = _c.paddingRight, paddingTop = _c.paddingTop, paddingBottom = _c.paddingBottom;
        var rectX = bbox.x - paddingLeft;
        var rectWidth = bbox.width + paddingLeft + paddingRight;
        var rectHeight = bbox.height + paddingTop + paddingBottom;
        if (this.type === 'xAxis') {
            if (rectX < 0) {
                x = bbox.width / 2 + paddingLeft;
            }
            else if (rectX + rectWidth > chartWidth) {
                x = chartWidth - (bbox.width / 2 + paddingRight);
            }
        }
        if (this.type === 'yAxis') {
            if (rectX < 0) {
                x = rectWidth - paddingRight;
            }
            else if (rectX + rectWidth > chartWidth) {
                x = chartWidth - (rectWidth - paddingLeft);
            }
        }
        text.setAttr({
            x: x,
            y: y,
            text: formattedContent,
            textAlign: textAlign,
            textBaseline: textBaseline,
        });
        bgRect.setAttr({
            x: text.getBBox().x - paddingLeft,
            y: text.getBBox().y - paddingTop,
            width: rectWidth,
            height: rectHeight,
        });
    };
    Axis.prototype.formatCrossLabel = function (value) {
        if (this.isCategroy() || typeof value === 'string') {
            return value;
        }
        var ticks = this.scale.getTicks();
        var interval = (ticks[ticks.length - 1] - ticks[0]) / (ticks.length - 1);
        var precision = Math.floor(log10(Math.abs(interval)));
        // todo 和linear.ts逻辑复用
        var out;
        if (!isNaN(precision) && !lodash.isNumber(this.option.interval)) {
            if (precision >= 0) {
                out = value.toFixed(2);
            }
            else {
                out = value.toFixed((precision - 2) * -1);
            }
            if (out.indexOf('.') !== -1) {
                out = out.replace(/0+$/, '').replace(/\.$/, '');
            }
        }
        else {
            out = value.toString();
        }
        return out;
    };
    return Axis;
}(ComponentModel));
export default Axis;
